import Vue from 'vue';

import formatters from '../lib/formatters';

Vue.filter('timestamp', formatters.datetime.formatTimestamp);

Vue.filter('capitalise', formatters.strings.capitalise);
Vue.filter('caps', formatters.strings.toCaps);

Vue.filter('truncate', formatters.strings.truncate);

Vue.filter('round', formatters.numbers.round);
